import React, { useState } from 'react';
import { Cake, Loader2, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Agent profile: birthday for the Calendar Autopilot (teammates see it; the agent gets a greeting). */
export default function BirthdayField({ agent, onUpdate }) {
  const [value, setValue] = useState(agent?.birthday || '');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    if (!value) return;
    setSaving(true);
    try {
      const r = await fetch(`${API_URL}/api/agents/${agent.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ birthday: value }) });
      if (r.ok) {
        const merged = { ...agent, birthday: value };
        sessionStorage.setItem('agent_session', JSON.stringify(merged));
        onUpdate?.(merged);
        setSaved(true); setTimeout(() => setSaved(false), 2000);
      } else alert('Could not save birthday');
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="profile-birthday">
      <label className="text-sm text-gray-500 flex items-center gap-1"><Cake className="h-3.5 w-3.5 text-pink-600" /> Date of Birth</label>
      <div className="flex items-center gap-2 mt-0.5">
        <input type="date" value={value} onChange={(e) => setValue(e.target.value)} className="border rounded px-2 py-1 text-sm" data-testid="profile-birthday-input" />
        <button type="button" onClick={save} disabled={saving || !value || value === agent?.birthday} className="text-xs px-2 py-1 rounded bg-[#0077B6] text-white disabled:opacity-40 flex items-center gap-1" data-testid="profile-birthday-save">
          {saving ? <Loader2 className="h-3 w-3 animate-spin" /> : saved ? <Check className="h-3 w-3" /> : null}{saved ? 'Saved' : 'Save'}
        </button>
      </div>
      <p className="text-[11px] text-gray-400 mt-0.5">Only the month and day appear on the team calendar; you'll receive a birthday greeting from Utmost.</p>
    </div>
  );
}
